import React, { Suspense } from "react"
import ReactHtmlParser from "react-html-parser"
import * as path from "../constants/Paths"

const BookingStarter = React.lazy(() => import(/* webpackPrefetch: true */ "../components/bookingStarter"))

const ParkingProductBookingStarterComponent = ({ container, productData = {}, modalCloseCallBack = undefined }) => {
  const lang = document.body.dataset.language || "da"
  const { heading = "", buttonText = "", product = "", fromLabel, toLabel, timeLabel, leadTimeInHours = 1.0 } = productData

  const textKeys = {
    from: fromLabel,
    to: toLabel,
    time: timeLabel,
  }

  const performParkingSearch = (arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode) => {
    const url = `${path.SEARCH(lang)}?ad=${arrivalDate}&at=${arrivalTime}&dd=${departureDate}&dt=${departureTime}${
      voucher ? "voucher=" + voucher : ""
    }${affiliateCode ? "&affiliate=" + affiliateCode : ""}`
    window.location.assign(url)
  }

  const closeModal = () => {
    if (container) container.style.display = "none"
    if (modalCloseCallBack) {
      modalCloseCallBack()
    }
  }

  return (
    <Suspense fallback={ReactHtmlParser(container?.innerHTML || "")}>
      <div className="overlay overlay--modal overlay--fixed is-active">
        <div className="modal modal--takeover">
          <button className="button button--icon js--close-modal" onClick={closeModal}>
            <span className="icon">
              <svg className="svg-icon svg-icon--close-new">
                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-close-new">
                  &nbsp;
                </use>
              </svg>
            </span>
          </button>
          <div className="modal__content">
            <div className="modal__content__inner">
              <div className="modal__middle">
                <BookingStarter
                  textKeys={textKeys}
                  showDefaultDates={false}
                  locale={lang}
                  headline={heading || "Book parkering"}
                  button={buttonText || "Book nu"}
                  productName={product}
                  leadTimeInHours={leadTimeInHours || 1.0}
                  performParkingSearch={performParkingSearch}
                  campaignCode={false}
                  replaceHistory={false}
                  searchOnBlur={false}
                  fontColor={"cph-white"}
                  isInModal={true}
                  slimVersion={true}
                />
                <div className="w--normal"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Suspense>
  )
}

export default ParkingProductBookingStarterComponent
